import {
  FlexCheckoutArgs,
  FlexLockStatusResponse,
  FlexMultiAssetCheckoutArgs,
  FlexVABMultiAssetCheckoutQuery,
  FlexZoomCommandResponse
} from '../autogenerated/ZoomBridge';
import GetLockStatusQuery from '../queries/lockstatus/GetLockStatusQuery';
import ErrorHandler from '../error/ErrorHandler';
import t from '../i18n/I18n';
import { clearSelectedItems, issueRefresh } from '../util/AssetsUtil';
import { getParentPath } from '../util/FileUtil';
import SaveSettings from '../queries/settings/SaveSettings';
import StringUtil from '../util/StringUtil';

export default class CheckoutController {
  // first check the lock on files
  // get default path for checkout
  // issue checkout command

  items = undefined;
  checkoutTarget = undefined;
  updateProgress = _.noop;
  query = undefined;
  args: FlexMultiAssetCheckoutArgs = undefined;

  constructor(
    items: [],
    checkoutWithLinks,
    checkoutWithLinksAndProxy,
    updateProgress,
    openUserAction = 'checkout',
    directCheckout = false
  ) {
    this.items = items;
    this.taskId = 0;
    this.checkoutWithLinks = checkoutWithLinks;
    this.checkoutWithLinksAndProxy = checkoutWithLinksAndProxy;
    this.updateProgress = updateProgress;
    this.action = openUserAction;
    this.directCheckout = directCheckout;
  }

  run() {
    if (this.action === 'open') {
      this.performCheckoutOperation();
    } else if (this.directCheckout) {
      this.performCheckoutOperation();
    } else this.checkLockStatus();
  }

  onFileSelect(event) {
    let files = event.target.files;
    const pathName = files[0].path;
    const parentPath = getParentPath(pathName);
    if (parentPath) {
      this.checkoutTarget = parentPath;
    }
    this.performCheckoutOperation();
  }

  checkLockStatus() {
    //if needed based on configs
    let filePaths = [];
    let dirFuids = [];
    for (const item of this.items) {
      if (item.getBasicFileAttributes().isFile()) {
        filePaths.push(item.getRemotePath());
      } else {
        dirFuids.push(item.getFuid());
      }
    }

    if (filePaths.length > 0 || dirFuids.length > 0) {
      new GetLockStatusQuery().run(filePaths, dirFuids).then(
        (resp) => {
          this.onLockStatusResponseReceived(resp);
        },
        (error) => {
          ErrorHandler.handleError(error);
        }
      );
    }
  }

  onLockStatusResponseReceived(resp: FlexLockStatusResponse) {
    if (resp) {
      this.doCheckoutWithLock();
      /*const isLockedByOthers: Boolean = resp.isFileLockedByOtherUsers();
      if (isLockedByOthers) {
        if (this.items.length === 1 && resp.getOtherUsersName() != null && resp.getOtherUsersName().length > 0) {
          const __lockOwner = resp.getOtherUsersName()[0];
          Msg.confirmYesNo(Localizer.getString("WARN_FILE_IS_LOCKED_4_CO", [_lockStatusQuery.message.filePaths.getItemAt(0), __lockOwner]), warnFileIsLockedCallback, Localizer.getString("DEF_TITLE"));
        } else {
           Msg.confirmYesNo(Localizer.getString("WARN_FILES_LOCKED_BY_OTHERS"), warnFileIsLockedCallback, Localizer.getString("DEF_TITLE"));
        }
      } else {
        if (VABSettingsUtil.askLockBeforeCheckout()) {
          Msg.confirmYesNoCancel(Localizer.getString("DO_WANT_TO_TAKE_LOCK_4_EDIT"), wantToTakeLockCallback, Localizer.getString("DEF_TITLE"));
        }
        else
          doCheckoutWithLock(repoItems, VABSettingsUtil.isAutoCO_OnLock(), checkoutDestination);
      }*/
    } else {
      this.doCheckoutWithLock();
    }
  }

  updateProgressMsg(num, msg, state) {
    if (this.updateProgress) {
      this.updateProgress(num, msg, state);
    }
  }

  performCheckoutOperation() {
    this.updateProgressMsg(0, t('PLEASE_WAIT'), 'RUNNING');
    this.query = new FlexVABMultiAssetCheckoutQuery();
    this.args = new FlexMultiAssetCheckoutArgs();
    this.query.message = this.args;

    this.args._checkoutDestination = this.checkoutTarget;
    this.args._checkoutWithLinks = this.checkoutWithLinks || this.checkoutWithLinksAndProxy;
    this.args._ignoreProxy = this.checkoutWithLinks;
    if (this.taskId > 0) {
      this.args._taskId = this.taskId;
    } else {
      this.args._assetDetails = CheckoutController.createCheckoutArgs(
        this.items,
        this.args.getCheckoutDestination(),
        null,
        null,
        null,
        this.takeLock
      );
      this.args._userAction = this.action;
      this.args.setNoFileOpen(!SaveSettings.getBoolean(SaveSettings.OPEN_ASSET_AFTER_CHECKOUT));
    }
    this.issueCheckout().then(
      (resp) => {
        clearSelectedItems();
        issueRefresh();
        // forceUpdateStatus(this.items, this.args.isCheckoutWithLinks());
        // setTimeout(() => {
        //   forceReRender();
        // }, 2000);
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  }

  doCheckoutWithLock() {
    const checkoutLockSetting = SaveSettings.get('LOCK_CHECKOUT_SETTING', 'Always');
    if (StringUtil.equals(checkoutLockSetting, 'always')) {
      this.takeLock = true;
    } else if (StringUtil.equals(checkoutLockSetting, 'never')) {
      this.takeLock = false;
    } else {
      this.isOpenConfirmDialog();
      return;
      //show confirmation diaog
    }
    if (window.gs.defaultCheckoutPath) {
      this.checkoutTarget = window.gs.defaultCheckoutPath;
      this.performCheckoutOperation();
    } else {
      //defaultcheckoutPath not present
      this.buildFileSelector(this).click();
    }
  }

  isOpenConfirmDialog = () => {
    if (window.gs.setCheckOutConfirmDialogProps) {
      const checkOutProps = {
        onClose: () => this.checkOutWithConfirm(false),
        msg: t('DO_WANT_TO_TAKE_LOCK_4_EDIT'),
        title: t('REMOVE_MODAL.TITLE_CONFIRM'),
        onYes: () => this.checkOutWithConfirm(true),
        onCross: () => this.checkOutWithConfirm(null)
      };
      window.gs.setCheckOutConfirmDialogProps(checkOutProps);
    }
  };

  checkOutWithConfirm = (takeLock) => {
    window.gs.setCheckOutConfirmDialogProps(null);
    if (takeLock !== null) {
      this.takeLock = takeLock;
      if (window.gs.defaultCheckoutPath) {
        this.checkoutTarget = window.gs.defaultCheckoutPath;
        this.performCheckoutOperation();
      } else {
        this.buildFileSelector(this).click();
      }
    }
  };

  buildFileSelector(_instance) {
    const fileSelector = document.createElement('input');
    fileSelector.setAttribute('type', 'file');
    fileSelector.setAttribute('mozdirectory', 'mozdirectory');
    fileSelector.setAttribute('webkitdirectory', 'webkitdirectory');
    fileSelector.onchange = function(event) {
      _instance.onFileSelect(event);
    };
    return fileSelector;
  }

  issueCheckout() {
    return new Promise((onSuccess, onFailure) => {
      this.executeQuery(onSuccess, onFailure);
    });
  }

  executeQuery(onSuccess, onFailure) {
    this.query.run().then(
      (resp) => {
        if (!resp.isIsRunning()) {
          const respone: FlexZoomCommandResponse = resp;
          if (
            respone.getSuccessMessage() &&
            respone.getSuccessMessage().length > 0 &&
            this.args._userAction === 'checkout'
          ) {
            if (!respone.isSuccess()) {
              ErrorHandler.handleError(respone.getSuccessMessage());
            } else {
              //toast(respone.getSuccessMessage());
            }
          }
          this.updateProgressMsg(100, respone.getSuccessMessage(), 'DONE');
          onSuccess(resp);
        } else {
          let progressMessage = resp.getProgressMessage();
          let progress = resp.getProgress();
          this.updateProgressMsg(progress, progressMessage, 'RUNNING');
          setTimeout(() => {
            this.executeQuery(onSuccess, onFailure);
          }, 1000);
        }
      },
      (failedResp) => {
        onFailure(failedResp);
      }
    );
  }

  static createCheckoutArgs(
    items: [],
    checkoutDest,
    additionalPath2Checkout = null,
    onlyAdditionalPathCO = null,
    useDestForAdditionalPathCo = null,
    takeLock = false
  ) {
    let infiles: Array = [];

    for (const item of items) {
      let assetDetails: FlexCheckoutArgs = new FlexCheckoutArgs();
      assetDetails.setBranch('Head');
      assetDetails.setCheckoutDestination(checkoutDest);

      if (typeof item === 'string' || item instanceof String) {
        assetDetails.setInfiles([item]);
        assetDetails.setRrn(-1);
      } else {
        if (item.getBasicFileAttributes().isFile()) {
          assetDetails.setRrn(item.getRrn());
        }
        if (item.getFuid() === -1) {
          assetDetails.setInfiles([item.getRemotePath()]);
        } else {
          assetDetails.setInFuid(item.getFuid());
        }
        assetDetails.setLockFiles(takeLock);
        if (takeLock) {
          if (item.getFuid() > 0) {
            assetDetails.setFuid2Lock(item.getFuid());
          } else {
            assetDetails.setPath2Lock(item.getRemotePath());
          }
        }
      }
      assetDetails.setNoKids(false);
      assetDetails.setExtraDirPathToAddAndCo(additionalPath2Checkout);
      assetDetails.setOnlyAdditionalPathCO(onlyAdditionalPathCO);
      assetDetails.setUseDestForAddtionalPathCo(useDestForAdditionalPathCo);

      infiles.push(assetDetails);
    }

    return infiles;
  }
}
